// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { useLocales } from "react-localized"
import { ContextMenuContainer, useContextMenu } from "../lib"
import { PurchaseOrder, PurchaseOrderProduct, PurchaseOrderProductDTO } from "../models"
import { OrderProductEditComponent } from "./OrderProductEditComponent"


const OrderProductEditorEditContextPanel: React.FC<{
  index: number,
  order: PurchaseOrder,
  row: PurchaseOrderProduct,
}> = ({
  index,
  order,
  row,
}) => {
  const {gettext} = useLocales()
  const panelCtx = useContextMenu()
  return (
    <ContextMenuContainer
      close={() => panelCtx.close()}
      isOpen={true}
      title={gettext("Change product details")}
    >
      <OrderProductEditComponent
        currency={order.getCurrency()}
        item={row.asDataTransferObject()}
        onDelete={() => {
          order.removeLine(index)
          panelCtx.close()
        }}
        onUpdate={(dto: PurchaseOrderProductDTO) => {
          console.log(row)
          row.update(dto)
          panelCtx.close()
        }}
      />
    </ContextMenuContainer>
  )
}

export {OrderProductEditorEditContextPanel}